import { GA_ACTION, GA_CATEGORIES } from "utils/constants";
import { triggerGa } from "utils/gaUtils";

// The intro plays before any page sets pageName/screenName.
const INTRO_PAGE = "campaign_intro";

export type SplashIntroEndReason =
  | "app_loaded"
  | "max_duration"
  | "load_error"
  | "disabled";

/** GA events that measure whether creators actually saw a campaign. */
export const campaignGA = {
  bannerView: ({
    campaignId,
    page,
    screenName,
  }: {
    campaignId: string;
    page: string;
    screenName: string;
  }) => {
    triggerGa({
      category: GA_CATEGORIES.IMPRESSION,
      action: GA_ACTION.CAMPAIGN_BANNER_VIEW,
      label: campaignId,
      label2: page,
      page,
      screenName,
    });
  },

  introView: ({ campaignId }: { campaignId: string }) => {
    triggerGa({
      category: GA_CATEGORIES.IMPRESSION,
      action: GA_ACTION.CAMPAIGN_INTRO_VIEW,
      label: campaignId,
      page: INTRO_PAGE,
      screenName: INTRO_PAGE,
    });
  },

  introEnd: ({
    campaignId,
    reason,
    wasAnimationShown,
    durationMs,
  }: {
    campaignId: string;
    reason: SplashIntroEndReason;
    wasAnimationShown: boolean;
    durationMs: number;
  }) => {
    triggerGa({
      category: GA_CATEGORIES.IMPRESSION,
      action: GA_ACTION.CAMPAIGN_INTRO_END,
      label: campaignId,
      label2: reason,
      label3: wasAnimationShown ? "animation_shown" : "animation_not_shown",
      page: INTRO_PAGE,
      screenName: INTRO_PAGE,
      eventValue: Math.round(durationMs),
    });
  },
};
